<template>
    <section class="gmp-section gmp-mb-std">
        <div class="features-module">
            <div class="h-c-page">

                <div class="h-c-grid features-module__row">
                    <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 h-c-grid__col-l--order-1 features-module__content--left">
                        <h3 class="h-c-headline h-c-headline--one h-has-bottom-margin">
                            原料鲜度
                        </h3>
                        <p class="h-u-mb-std features-module__description">
                            确保每一批次的原料都保持在最佳状态。这有助于提升最终产品的品质，确保顾客享用到新鲜、优质的食品。
                        </p>
                    </div>

                    <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 h-c-grid__col-l--order-2 features-module__content--right">
                        <div class="glue-zippy-set h-t-hercules ng-scope glue-is-mixed">
                            <div class="glue-zippy-toggle-all" data-g-action="expand all0">
                                <span class="h-c-expansion-panels__toggle-text h-c-expansion-panels__toggle-text--expanded">
                               展开全部
                            </span>
                                <span class="h-c-expansion-panels__toggle-text h-c-expansion-panels__toggle-text--collapsed">
                                折叠全部
                            </span>
                                <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon h-c-icon--18px h-c-expansion-panels__toggle-circle" >
                                    <polyline points="0,0 4,4 8,0" style=" stroke:#177166; stroke-width:2" @click="expendAll(0)" />
                                </svg>
                            </div>

                            <ul class="h-c-expansion-panels__list">
                                <li class="glue-zippy glue-a-zippy--v-smooth-expand ng-isolate-scope glue-c-zippy ">
                                    <div class="glue-zippy-btn ng-isolate-scope glue-c-zippy__btn">
                                        <h4 class="h-c-expansion-panels__button-header">
                                            原料的保鲜报警设置
                                        </h4>

                                        <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon--18px h-c-expansion-panels__button-arrow" @click="addExpend(1,0)">
                                            <polyline points="0,0 7,7 14,0" style="fill:white;stroke:#1a73e8;stroke-width:3" />
                                        </svg>

                                    </div>

                                    <div class="glue-zippy-content ng-isolate-scope glue-c-zippy__content">
                                        <div class="glue-c-zippy__collapse-region glue-collapse-expanded" id="zippy-1-content0">
                                            <div class="glue-c-zippy__content-container">
                                                <p class="ng-scope">
                                                    通过对需要精准管理和自动化提醒的商品，根据设置商品的保鲜参数，系统会自动计算出已达到报警时间的商品。
                                                    可以帮助企业分析哪些原料容易接近保质期但未及时使用，使管理人员及时做出不同商品的处理措施，避免重复的浪费和损失。
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </li>
                                <li class="glue-zippy glue-a-zippy--v-smooth-expand ng-isolate-scope glue-c-zippy ">
                                    <div class="glue-zippy-btn ng-isolate-scope glue-c-zippy__btn">
                                        <h4 class="h-c-expansion-panels__button-header">
                                            原料的废弃时间设置
                                        </h4>

                                        <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon--18px h-c-expansion-panels__button-arrow" @click="addExpend(2,0)">
                                            <polyline points="0,0 7,7 14,0" style="fill:white;stroke:#1a73e8;stroke-width:3" />
                                        </svg>

                                    </div>

                                    <div class="glue-zippy-content ng-isolate-scope glue-c-zippy__content">
                                        <div class="glue-c-zippy__collapse-region glue-collapse-expanded" id="zippy-2-content0">
                                            <div class="glue-c-zippy__content-container">
                                                <p class="ng-scope">
                                                    操作人员可以通过系统的废弃功能，轻松地处理到期商品，不需要手动记录和跟踪每个商品的保质期。
                                                    系统自动化处理减少了人为错误的风险，确保所有过期商品都能及时废弃。
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </li>

                                <li class="glue-zippy glue-a-zippy--v-smooth-expand ng-isolate-scope glue-c-zippy ">
                                    <div class="glue-zippy-btn ng-isolate-scope glue-c-zippy__btn">
                                        <h4 class="h-c-expansion-panels__button-header">
                                            日鲜率
                                        </h4>

                                        <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon--18px h-c-expansion-panels__button-arrow" @click="addExpend(3,0)">
                                            <polyline points="0,0 7,7 14,0" style="fill:white;stroke:#1a73e8;stroke-width:3" />
                                        </svg>

                                    </div>

                                    <div class="glue-zippy-content ng-isolate-scope glue-c-zippy__content">
                                        <div class="glue-c-zippy__collapse-region glue-collapse-expanded" id="zippy-3-content0">
                                            <div class="glue-c-zippy__content-container">
                                                <p class="ng-scope">
                                                    企业可以实时跟踪当天使用的商品中，多少是当天进货的。这确保了食品的极高新鲜度，提升了产品的品质。
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </li>

                                <li class="glue-zippy glue-a-zippy--v-smooth-expand ng-isolate-scope glue-c-zippy ">
                                    <div class="glue-zippy-btn ng-isolate-scope glue-c-zippy__btn">
                                        <h4 class="h-c-expansion-panels__button-header">
                                            沽清时间统计
                                        </h4>

                                        <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon--18px h-c-expansion-panels__button-arrow" @click="addExpend(4,0)">
                                            <polyline points="0,0 7,7 14,0" style="fill:white;stroke:#1a73e8;stroke-width:3" />
                                        </svg>

                                    </div>

                                    <div class="glue-zippy-content ng-isolate-scope glue-c-zippy__content">
                                        <div class="glue-c-zippy__collapse-region glue-collapse-expanded" id="zippy-4-content0">
                                            <div class="glue-c-zippy__content-container">
                                                <p class="ng-scope">

                                                    通过分析每天的沽清时间，如果发现某商品经常在距离下班时间很久之前就沽清，管理者可以调整订货量，
                                                    确保在高需求时段有足够的库存供应，从而避免销售机会的流失。
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </li>

                            </ul>


                        </div>


                    </div>
                </div>




            </div>

        </div>


    </section>
</template>

<script>
    export default {
        name: "DS_features_module_two",
        methods: {

            expendAll(index){

                console.log(index)
                var expend = this.$('.gmp-mb-std').eq(index).find(".glue-zippy-toggle-all").attr('data-g-action');
                console.log(expend);
                // var expend = this.$('.glue-zippy-toggle-all').attr('data-g-action');
                var aaas =  this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow');
                if(expend === 'expand all'+index){
                    console.log("towowowowoowoowowoowoowparenenetnntnntnnDS_features_module_zero")
                    for(var i = 1; i < aaas.length +1 ; i++){
                         this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow').eq([i-1]).parent().parent().addClass('glue-is-expanded');
                        this.$('.gmp-mb-std').eq(index).find('#zippy-'+i +'-content'+index).css({
                            "max-height": "100%",
                        })
                    }
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-set').removeClass('glue-is-mixed').addClass('glue-is-expanded');
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-toggle-all').attr("data-g-action","collapse all"+index)

                }else{
                    for(var j = 1; j < aaas.length +1 ; j++){
                        var aaa1 =  this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow')[j-1];
                        this.$(aaa1).parent().parent().removeClass('glue-is-expanded');
                        this.$('#zippy-'+ j +'-content'+index).css({
                            "max-height": "0",
                        })
                    }
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-set').addClass('glue-is-mixed').removeClass('glue-is-expanded');
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-toggle-all').attr("data-g-action","expand all" +index)
                }
            },

            addExpend(index,which) {
                var aaa =  this.$('.gmp-mb-std').eq(which).find('.h-c-expansion-panels__button-arrow')[index-1];
                var fatherExpend = this.$('.gmp-mb-std').eq(which).find(aaa).parent().parent().is('.glue-is-expanded');
                if(fatherExpend){
                    this.$('.gmp-mb-std').eq(which).find('#zippy-'+index+'-content'+ which).css({
                        "max-height": "0",
                    })
                    this.$(aaa).parent().parent().removeClass('glue-is-expanded');
                    this.$('.glue-zippy-toggle-all').attr("data-g-action","expand all")
                    this.$('.glue-zippy-set').addClass('glue-is-mixed').removeClass('glue-is-expanded');

                }else{
                    this.$(aaa).parent().parent().addClass('glue-is-expanded');
                    this.$('#zippy-'+index+'-content' + which).css({
                        "max-height": "100%",
                    })
                }

            }


        },
    }
</script>

<style lang="less">


</style>